import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { components } from 'react-select';
var Input = function Input(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _props$selectProps$in = props.selectProps.inputProps,
    inputProps = _props$selectProps$in === void 0 ? {} : _props$selectProps$in;
  return /*#__PURE__*/React.createElement(components.Input, _extends({}, props, inputProps));
};
export default /*#__PURE__*/memo(Input);